import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import ContractForm from './ContractForm';
import DateSelector from '../../commonComponents/DateSelector';

const SpecificReservationData = (props) => {
  const {
    reservation,
    readOnly,
    defaultLang,
    handleBookingDate
  } = props;

  const {
    id,
    contract,
    rateCode,
    fromDate,
    bookingDate
  } = reservation;
console.log(reservation)
  const reservationData = {
    id,
    contract,
    rateCode,
    fromDate
  };

  const handleReservationBookingDate = (bookinDate) => {
    handleBookingDate(id, bookinDate);
  };

  const customColSize = (readOnly) ? '2' : '6';

  return (
    <Row className="auto-margin no-padding">
      <Col sm={customColSize}>
        <ContractForm
          reservationData={reservationData}
          readOnly={readOnly}
        />
      </Col>
      <Col sm="4">
        <DateSelector
          title={translate('fechaEmision')}
          dataTestLabel="fecha-emision"
          defaultDate={bookingDate}
          defaultLang={defaultLang}
          readOnly={readOnly}
          checkPrevProps
          handleDateSelected={handleReservationBookingDate}
        />
      </Col>
    </Row>
  );
};

SpecificReservationData.propTypes = {
  reservation: PropTypes.object.isRequired,
  defaultLang: PropTypes.string,
  readOnly: PropTypes.bool,
  handleBookingDate: PropTypes.func
};

SpecificReservationData.defaultProps = {
  defaultLang: 'es',
  readOnly: false,
  handleBookingDate: () => {}
};

export default SpecificReservationData;
